export const ASCENDENTE = "ascendente";
export const DESCENDENTE = "descendente";
